import XModal from "./XModal";

const ConfirmModal = ({ options, onConfirm, onCancel }) => {
   if (!options) return null;

   const {
      title = "Are you sure?",
      description,
      confirmText = "Confirm",
      cancelText = "Cancel",
      size = "sm",
   } = options;

   return (
      <XModal
         isOpen
         title={title}
         onClose={onCancel}
         onSubmit={onConfirm}
         submitText={confirmText}
         cancelText={cancelText}
         size={size}
      >
         {description && <p className="mb-0">{description}</p>}
      </XModal>
   );
};

export default ConfirmModal;
